<template>

    <v-page-widget class="notes" title="Notes" actionTitle="Edit" :actionFunc="editNotes" :empty="!customer.notes">
        <template #body v-if="!customer.notes">
            <v-notice size="sm" message="No Notes" />
        </template>
        <template #body v-else>
            <p class="m-0">{{ customer.notes }}</p>
        </template>
    </v-page-widget>

</template>

<style lang="scss">

    .page-widget.notes {
        .page-widget-header,
        .page-widget-body {
            background: #ffffe0 !important;
            border-color: #d9d0c8 !important;
        }
        .page-widget-body {
            max-height: 250px !important;
            overflow-y: auto !important;
        }
        .notice {
            background: transparent !important;
            border-color: #d9d0c8 !important;
        }
    }

</style>

<script>

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        }
    },

    methods: {

        editNotes() {
            this.$store.commit('showModal', 'notes');
        },

    },

}

</script>
